// extracted by mini-css-extract-plugin
export default {"Container":"OrderPostitions_Container__gRkZP","Container_Danger":"OrderPostitions_Container_Danger__lLuNU"};